<template>
  <div class="support-area">
    <aside class="support-sidebar">
      <h5>Users</h5>
      <ul v-for="room in rooms" :key="room.id" class="room" :class="[currentRoom && currentRoom.id === room.id ? 'active' : '']">
        <li          
          @click="connectToRoom(room.id)"
        >
        {{ room.name }}
        </li>
      </ul>
    </aside>
    <section class="support-session">
      <header class="current-chat">
        <h5 v-if="currentRoom">{{ currentRoom.name }}</h5>
        <h5 v-else>Chat</h5>
      </header>
      <div class="chat-session">
        <div v-for="message in messages" :key="message.id">
          <span :class="[ message.senderId === currentUser.id ? 'support' : 'user']" class="message">{{ message.text }}</span>
        </div>
      </div>
      <form @submit.prevent="sendMessage" class="message-form">
        <input
          class="message-input"
          autofocus
          placeholder="Compose your message and hit ENTER to send"
          v-model="newMessage"
          name="newMessage"
          />
      </form>
    </section>
  </div>
</template>

<script>
  import { sendMessage, connectToRoom } from '@/chat/chat.js';
  import Chatkit from '@pusher/chatkit-client';
  import axios from 'axios';

  export default {
    name: 'Support',
    data() {
      return {
        newMessage: '',
        currentUser: null,
        currentRoom: null,
        rooms: [],
        messages: [],
      }
    },
    methods: {
      sendMessage,
      connectToRoom,
    },
    mounted() {
      const userId = 'support';
      //Production
      //const UR = 'http://35.242.182.168:5200';
      //Test
      //const URL = 'http://192.168.1.71:5200';

      axios
        .post('http://localhost:5200/users', { userId })
        .then(() => {
          const tokenProvider = new Chatkit.TokenProvider({
            url: 'http://localhost:5200/authenticate',
          });

          const chatManager = new Chatkit.ChatManager({
            instanceLocator: 'v1:us1:7d4832cd-281d-4006-bcbe-2347557d75b2',
            userId,
            tokenProvider,
          });

          return chatManager
            .connect({
              onAddedToRoom: room => {
                this.rooms = [...this.rooms, room];
              },
            })
            .then(currentUser => {
              this.currentUser = currentUser;
              this.rooms = currentUser.rooms;
              if (this.rooms.length >= 1) {
                this.connectToRoom(this.rooms[0].id);
              }
            });
        })
        .catch(console.error);
    }
  }
</script>

<style>
  .support-area {
    width: 100vw;
    height: 480px;
    display: flex;
  }

  .support-sidebar {
    width: 20%;
    background-color: beige;
    height: 100%;
    border-right: 1px solid #ccc;
  }

  .support-sidebar ul {
    list-style: none;
    border-bottom: 1px solid #ccc;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .support-sidebar ul:hover {
    background-color: #f4f4ff;
  }

  .support-sidebar h5 {
    color: black;
    margin: 0;
    text-align: left;
    padding: 10px 20px;
    border-bottom: 1px solid #ccc;
    
  }

  .room {
    font-size: 14px;
    color: black;
    cursor: pointer;
    text-align: left;
    padding: 10px 20px;
  
  }

  .room.active {
    background-color: #eaeafd;
    color: black;
  }

  .support-session {
    width: 80%;
    height: 100%;
    display: flex;
    flex-direction: column;
 
  }

  .current-chat {
    border-bottom: 1px solid #ccc;
    text-align: left;
    padding: 10px 20px;
    display: flex;
    background-color: beige;
  }

  .current-chat h5 {
    margin-bottom: 0;
  }

  .chat-session {
    flex-grow: 1;
    overflow-y: auto;
    padding: 10px 50px;
    font-size: 12px;
  }

  .message {
    background-color: #f6f6f6;
    clear: both;
    margin-bottom: 15px;
    padding: 10px;
    border-radius: 5px;
    max-width: 80%;
  }

  .message.user {
    float: right;
    background-color: peachpuff;
  }

  .message.support {
    float: left;
    background-color: #ddd;
  }

  .message-form, .message-input {
    width: 100%;
    margin-bottom: 0;
  }

  .message-input {
    border-radius: 0;
    border: none;
    border-top: 1px solid #ccc;
    height: 50px;
    padding: 20px;
    font-size: 14px;
    background-color: #f6f6f6
  }
</style>